class SiteDropdownMenu {
	constructor() {
		this.menu = document.querySelector('#site-dropdown-menu');
		this.menuItems = this.menu?.querySelectorAll('.menu-item');
		this.subMenuItems = this.menu?.querySelectorAll('.sub-menu');
		this.navDropdownBtn = document.querySelector('.main-header__icons .nav-dropdown button');
		this.menuContainer = document.querySelector('.nav-dropdown__menu-container');
		this.menuTitle = document.querySelector('.nav-dropdown__title h2');
		this.currentLanguage = this.menu?.querySelector('.current-website');
		this.currentCountry = this.currentLanguage
			? this.currentLanguage.parentElement.parentElement
			: null;
		this.currentRegion = this.currentCountry
			? this.currentCountry.parentElement.parentElement
			: null;
	}

	init() {
		if (!this.menu) return;
		if (!this.navDropdownBtn) return;

		this.hideSubMenuItems();
		this.setCurrentWebsiteClasses();
		this.handleMenuItemsClick();
		this.navDropdownBtn.addEventListener('click', (event) => {
			const { currentTarget } = event;
			const ariaExpanded = currentTarget.getAttribute('aria-expanded');
			if (ariaExpanded === 'true') {
				this.resetMenuClasses();
				this.hideSubMenuItems();
				this.showCurrentWebsiteDesktop();
			}
		});
		this.setCurrentWebsiteInMenuTitle();
		this.handleCloseButtonClick();
		this.handleBackButtonClick();
		this.handleHreflangTags();
		this.handleWindowResize();
		this.handleDesktopMenuPosition();
	}

	hideSubMenuItems() {
		if (!this.menu) return;

		this.subMenuItems.forEach((subMenu) => {
			subMenu.classList.add('hide');
		});
	}

	setCurrentWebsiteClasses() {
		if (this.currentCountry) {
			this.currentCountry.classList.add('current-country');
		}
		if (this.currentRegion) {
			this.currentRegion.classList.add('current-region');
		}
	}

	showCurrentWebsiteDesktop() {
		if (!this.menu) return;

		if (this.currentRegion) {
			this.currentRegion.classList.add('active');
			this.currentCountry.classList.add('active');
			this.currentLanguage.classList.add('active');
		}
		if (window.matchMedia('(min-width: 1199px)').matches) {
			const countrySubMenu = this.currentRegion.querySelector('.sub-menu');
			let languageSubMenu = null;
			if (countrySubMenu) {
				countrySubMenu.classList.remove('hide');
				const activeCountry = countrySubMenu.querySelector('.active');
				languageSubMenu = activeCountry?.querySelector('.sub-menu');
				languageSubMenu?.classList.remove('hide');
			}
		}
	}

	setCurrentWebsiteInMenuTitle() {
		if (!this.menu) return;
		const currentWebsite = this.menu.querySelector('.nav-dropdown__current-website b');
		const currentLanguage = this.currentLanguage.querySelector('a').innerText;
		const currentCountry = this.currentCountry.querySelector('button').innerText;
		currentWebsite.innerText = `${currentCountry} (${currentLanguage})`;
	}

	handleMenuItemsClick() {
		if (!this.menu) return;

		this.menuItems.forEach((item) => {
			item.addEventListener('click', (e) => {
				e.stopPropagation();

				if (!item.classList.contains('active')) {
					item.classList.add('active');
				}

				if (!item.querySelector('.sub-menu')) return;
				// hide or show the corresponding items
				const siblingElems = item.parentNode.children;
				for (let i = 0; i < siblingElems.length; i++) {
					if (siblingElems[i] !== item) {
						siblingElems[i].querySelector('.sub-menu').classList.add('hide');
						siblingElems[i].classList.remove('active');
					}
				}
				item.querySelector('.sub-menu').classList.remove('hide');

				if (window.matchMedia('(max-width: 1199px)').matches && this.menuContainer) {
					item.classList.add('active');
					if (item.classList.contains('menu-item-depth-0')) {
						this.menuContainer.classList.add('menu-item-depth-0');
					} else if (item.classList.contains('menu-item-depth-1')) {
						this.menuContainer.classList.add('menu-item-depth-1');
					}
					this.menuTitle.innerText = item.querySelector('button').innerText;
				}
			});
		});
	}

	handleWindowResize() {
		if (!this.menu) return;

		let currentWidth = window.innerWidth;
		window.addEventListener('resize', () => {
			const isMenuExpanded = this.navDropdownBtn.getAttribute('aria-expanded');
			const newWidth = window.innerWidth;
			if (
				(currentWidth >= 1200 && newWidth < 1200 && isMenuExpanded === 'true') ||
				(currentWidth < 1200 && newWidth >= 1200 && isMenuExpanded === 'true')
			) {
				this.closeMenu();
			}
			currentWidth = newWidth;
		});
	}

	resetMenuClasses() {
		if (!this.menu) return;

		const menuContainer = document.querySelector('.nav-dropdown__menu-container');
		if (menuContainer) {
			menuContainer.classList.remove(
				'menu-item-depth-0',
				'menu-item-depth-1',
				'menu-item-depth-2'
			);
		}

		if (this.menuItems) {
			this.menuItems.forEach((item) => {
				item.classList.remove('active');
			});
		}
	}

	handleCloseButtonClick() {
		if (!this.menu) return;

		const closeButton = document.querySelector('.nav-dropdown__dropdown .close-btn');
		if (!closeButton) return;
		closeButton.addEventListener('click', () => {
			this.closeMenu();
		});
	}

	handleBackButtonClick() {
		if (!this.menu) return;

		const backButton = document.querySelector('.nav-dropdown__dropdown .back-btn');
		if (!backButton) return;
		backButton.addEventListener('click', () => {
			if (this.menuContainer.classList.contains('menu-item-depth-1')) {
				this.menuContainer.classList.remove('menu-item-depth-1');
				this.menu.querySelectorAll('.menu-item-depth-1 .sub-menu').forEach((item) => {
					item.classList.add('hide');
				});
				const activeItem = document.querySelector('.menu-item-depth-1.active');
				activeItem.classList.remove('active');
				this.menuTitle.innerText = this.menu.querySelector('li.active button').innerText;
			} else if (this.menuContainer.classList.contains('menu-item-depth-0')) {
				this.menuContainer.classList.remove('menu-item-depth-0');
				this.hideSubMenuItems();
				const activeItem = this.menu.querySelector('li.active');
				activeItem.classList.remove('active');
				this.menuTitle.innerText = this.menuTitle.dataset.regionLangTitle;
			}
		});
	}

	handleHreflangTags() {
		if (!this.menu) return;

		// get all hreflang tag values on this page
		const hreflangTags = document.querySelectorAll('link[rel="alternate"][hreflang]');
		const hreflangValues = Array.from(hreflangTags).map((tag) => ({
			hreflang: tag.getAttribute('hreflang'),
			href: tag.getAttribute('href'),
		}));

		// query this.menuItems and get the ones that contain a css class starting with 'hreflang'
		const hreflangMenuItems = Array.from(this.menuItems).filter((item) =>
			Array.from(item.classList).some((className) => className.startsWith('hreflang-'))
		);

		// loop through hreflangMenuItems and set the href attribute to the corresponding hreflang value
		hreflangMenuItems.forEach((item) => {
			const hreflangClass = Array.from(item.classList).find((className) =>
				className.startsWith('hreflang-')
			);
			const hreflangValue = hreflangClass.replace('hreflang-', '');
			const matchingHreflang = hreflangValues.find(
				(tag) => tag.hreflang.toLowerCase() === hreflangValue.toLowerCase()
			);
			if (matchingHreflang) {
				const linkElement = item.querySelector('a');
				if (linkElement) {
					linkElement.setAttribute('href', matchingHreflang.href);
				}
			}
		});
	}

	handleDesktopMenuPosition() {
		if (!this.menu) return;

		const secondaryCTA = document.querySelector('.main-header__secondary-cta');
		const navDropdown = document.querySelector('.nav-dropdown--login');
		const primaryCTA = document.querySelector('.main-header__primary-cta');
		let countHiddenCTAs = 0;
		if (secondaryCTA === null || window.getComputedStyle(secondaryCTA).display === 'none') {
			countHiddenCTAs++;
		}
		if (navDropdown === null || window.getComputedStyle(navDropdown).display === 'none') {
			countHiddenCTAs++;
		}
		if (primaryCTA === null) {
			countHiddenCTAs++;
		}
		if (countHiddenCTAs === 1) {
			this.menu.classList.add('down-one-cta');
		} else if (countHiddenCTAs === 2) {
			this.menu.classList.add('down-two-ctas');
		} else if (countHiddenCTAs === 3) {
			this.menu.classList.add('down-three-ctas');
		}
	}

	closeMenu() {
		this.menuTitle.innerText = this.menuTitle.dataset.regionLangTitle;
		this.navDropdownBtn.click();
	}
}

export default new SiteDropdownMenu();
